import { fetcher } from '@commenda/utils';
import { WriteToUsInquiryType } from './types';

export interface CreateWriteToUsSupportInquiry {
  type: WriteToUsInquiryType;
  description: string;
  fileUrls?: string[];
  phoneNumber?: string;
}

/**
 * Submits a user inquiry (bug report, question, or feedback) to the support team
 *
 * @param data WriteToUsDto containing the inquiry type, description, and optional file URLs
 * @returns Promise with success status and optional message
 */
export async function writeToUs(data: CreateWriteToUsSupportInquiry) {
  const response = await fetcher('support/write-to-us', {
    method: 'POST',
    body: data,
  });

  return response;
}
